import { useMemo } from 'react';

import type { AiUsageEndpoint } from '@/api/types';
import { DataTable, type DataTableColumn } from '@/design-system';

interface EndpointsTableProps {
  endpoints: readonly AiUsageEndpoint[];
  top?: number;
}

const usd = (value: number): string =>
  value.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });
const integer = (value: number): string => value.toLocaleString();

export function EndpointsTable({ endpoints, top = 15 }: EndpointsTableProps) {
  const items = useMemo(() => endpoints.slice(0, top), [endpoints, top]);
  const columns = useMemo<readonly DataTableColumn<AiUsageEndpoint>[]>(() => [
    { id: 'route', header: 'Route', getValue: (item) => item.reqName, renderCell: (item) => item.reqName, width: 280 },
    { id: 'actions', header: 'Actions', getValue: (item) => item.actions, renderCell: (item) => integer(item.actions) },
    { id: 'aoai', header: 'AOAI', getValue: (item) => item.aoaiCalls, renderCell: (item) => integer(item.aoaiCalls) },
    { id: 'di', header: 'DI', getValue: (item) => item.diCalls, renderCell: (item) => integer(item.diCalls) },
    { id: 'pages', header: 'Pages', getValue: (item) => item.pages, renderCell: (item) => integer(item.pages) },
    { id: 'tokenCost', header: 'Token $', getValue: (item) => item.tokenCostUsd, renderCell: (item) => usd(item.tokenCostUsd) },
    { id: 'diCost', header: 'DI $', getValue: (item) => item.diCostUsd, renderCell: (item) => usd(item.diCostUsd) },
    { id: 'total', header: 'Total $', getValue: (item) => item.totalCostUsd, renderCell: (item) => usd(item.totalCostUsd) },
  ], []);

  return <DataTable ariaLabel="Top endpoints by allocated cost across the window" columns={columns} getRowId={(item) => item.reqName} items={items} tableId="ai-usage-endpoints" />;
}
